import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { useHistory, useParams, Route } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as helpers from './helpers.js'
import * as globals from './globals.js'
import * as Actions from './redux-actions.js'


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import SyncIcon from '@material-ui/icons/Sync';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {DateSelector, TimeSelector} from './DatePickers.jsx'







export const transfer_columns = [
  { id: 'book_id', label: 'Booking', minWidth: 30 },
  { id: 'booking_status', label: 'Booking status', minWidth: 100 ,
          format: (value) => {
              switch (value)  {
                case "CANCELED":
                  return (<b className="has-text-danger">{value}</b>)
                case "NOSHOWUP":
                  return (<b className="has-text-warning">{value}</b>)
                case "ACTIVE":
                  return (<b className="has-text-success">{value}</b>)
                default:
                  return (<b className="has-text-dark">{value}</b>)
              }
            }
      },
  { id: 'transfer_type_id', label: 'T.ID', minWidth: 30 },
  { id: 'transfer_type', label: 'Type', minWidth: 140 },
  {
    id: 'tfrom',
    label: 'From',
    minWidth: 70,
    align: 'right',
  },
  {
    id: 'pickup_date',
    label: 'Pickup date',
    minWidth: 100,
    align: 'right',
    format: (value) => moment(value).format('DD.MM.YYYY')
  },
  {
    id: 'pickup_time',
    label: 'Pickup time',
    minWidth: 100,
    align: 'right',
    format: (value) => moment(value, 'HH:mm').format('HH:mm')
  },
  {
    id: 'flight_number',
    label: 'Flight',
    minWidth: 100,
    align: 'right'
  },
  {
    id: 'pickup_region',
    label: 'Pickup region',
    minWidth: 150,
    align: 'right'
  },
  {
    id: 'pickup_location',
    label: 'Pickup addr.',
    minWidth: 100,
    align: 'right'
  },
  {
    id: 'destination_region',
    label: 'Destination region',
    minWidth: 200,
    align: 'right'
  },
  {
    id: 'destination_location',
    label: 'Destination addr.',
    minWidth: 200,
    align: 'right'
  },
  {
    id: 'return_trip',
    label: 'Return',
    minWidth: 200,
    align: 'right'
  },
  {
    id: 'return_date',
    label: 'Return date',
    minWidth: 200,
    align: 'right',
    format: (value) => value ? moment(value).format('DD.MM.YYYY') : ''
  },
  {
    id: 'return_time',
    label: 'Return time',
    minWidth: 200,
    align: 'right',
    format: (value) => value ? moment(value, 'HH:mm').format('HH:mm') : ''
  },
  {
    id: 'return_region',
    label: 'Return region',
    minWidth: 200,
    align: 'right'
  },
  {
    id: 'return_location',
    label: 'Return addr.',
    minWidth: 200,
    align: 'right'
  },
  {
    id: 'persons',
    label: 'Persons',
    minWidth: 200,
    align: 'right'
  },
 {
    id: 'baggage',
    label: 'Baggage',
    minWidth: 200,
    align: 'right'
  },
];




const useStyles = makeStyles((theme) => ({
  root: {
      width: "100%",
  },
  container: {
    maxHeight: props => props.maxHeight || 550,
  },
}));



function Transfers(props) {
  const { p1 } = useParams()
  const classes = useStyles()
  const serverStatus = useSelector(state => state.serverStatus)
  const authenticated = useSelector(state => state.authenticated)
  const current_role = useSelector(state => state.current_role)
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [days, setDays] = useState(60)
  const [bookid, setBookid] = useState(p1 ? p1 : null)
  const [data, setData] = useState([])
  const transfersRedux = useSelector(state => state.db.transfers)
  const [refresh, setRefresh] = useState(true)
  const [currrange, setCurrrange] = useState(null)
  const [transfers, setTransfers] = useState([])

  console.log('DEBUG', 'P1', p1)

  let daysInputField
  let bookIdInputField
                 
  useEffect(() => {
     if (transfersRedux) bookIdFilter()
  }, [bookid])


  useEffect(() => {
    
    if (bookid !== null) {
       bookIdFilter()
    
    } else {

    switch (currrange) {
      case "today":
         showToday()
         break;;

      case "tomorrow":
         showTomorrow()
         break;;

      case "7days":
         show7Days()
         break;;

      case "prev7days":
         showPrev7Days()
         break;;

      default:
        showAll()
      }
    
    }

  }, [transfersRedux])


  useEffect(() => {
     
     if (authenticated && serverStatus) {
       setLoaded(false)
       console.log('DEBUG','GET Transfers')
       helpers.getAPI(
         { func: (data, resp) => {
                 dispatch({type: Actions.SET_TRANSFERS, value: data})
                 setLoaded(true)
            }, 
           uri: globals.myAPIurl+'/getdb?tab=transfers&days='+days
         })
     }

  }, [authenticated, days, refresh]);



  const bookIdFilter = () => {
    setCurrrange(null)
    console.log('DEBUG','BOOKID', bookid)
    if (bookid && transfersRedux) {
      setTransfers(transfersRedux.filter((f)=>{
       return (f.book_id === Number(bookid) )
      }))
    } else {
      showAll()
    }

  }


  const showAll = () => {
    setCurrrange(null)
    setTransfers(transfersRedux)
  }


  const showToday = () => {
    setCurrrange("today")
    setTransfers(transfersRedux.filter((f)=>{
       return (moment(f.pickup_date).isSame(moment(), 'day') || (f.return_date && moment(f.return_date).isSame(moment(), 'day')))
    }))
  }


  const showTomorrow = () => {
    setCurrrange("tomorrow")
    setTransfers(transfersRedux.filter((f)=>{
       return (moment(f.pickup_date).isSame(moment().add(1, 'days'), 'day') || (f.return_date && moment(f.return_date).isSame(moment().add(1, 'days'), 'day')))
    }))
  }


  const show7Days = () => {
    setCurrrange("7days")
    setTransfers(transfersRedux.filter((f)=>{
       return (moment(f.pickup_date).isBetween(moment(), moment().add(7, 'days')) ||  (f.return_date && moment(f.return_date).isBetween(moment(), moment().add(7, 'days')))  )
    }))
  }

  
  const showPrev7Days = () => {
    setCurrrange("prev7days")
    setTransfers(transfersRedux.filter((f)=>{
       return (moment(f.pickup_date).isBetween(moment().subtract(7, 'days'), moment()) ||  (f.return_date && moment(f.return_date).isBetween(moment().subtract(7, 'days'), moment()))  )
    }))
  }




  const refreshData = () => {
     setRefresh(!refresh)
  }

  if (! loaded || ! transfers) return (<div className="section has-background-light">
                          <CircularProgress />
                        </div>)
  

  return (
  	<div>
     <div className="columns is-mobile">
       <div className="column is-10">
      <div class="field" style={{maxWidth: "3rem"}}>   
       <div class="control"> 
         <TextField
          id="transfers-days"
          label="Days"
          type="number"
          defaultValue={days}
          inputRef = {(c)=>daysInputField = c}
          onBlur={(e)=>{setDays(daysInputField.value)}}
        />
      </div>
     </div>

   <div class="field" style={{maxWidth: "5rem"}}>   
       <div class="control"> 
         <TextField
          id="transfers-bookid"
          label="Booking ID"
          type="number"
          defaultValue={bookid}
          inputRef = {(c)=>bookIdInputField = c}
          onBlur={() => {setBookid(bookIdInputField.value)} }
        />
      </div>
     </div>


      <ButtonGroup variant="contained" color="primary" aria-label="outlined primary button group">
        <Button color={currrange === null ? "secondary" : "primary"} onClick={showAll}>All</Button>
        <Button color={currrange === "prev7days" ? "secondary" : "primary"} onClick={showPrev7Days}>{"< 7 days"}</Button>
        <Button color={currrange === "today" ? "secondary" : "primary"} onClick={showToday}>Today</Button>
        <Button color={currrange === "tomorrow" ? "secondary" : "primary"} onClick={showTomorrow}>Tomorrow</Button>
        <Button color={currrange === "7days" ? "secondary" : "primary"} onClick={show7Days}>{"7 days >"}</Button>
      </ButtonGroup>

     </div>

     <div className="column is-2 has-text-right">
     
       <IconButton
        variant="contained"
        color="secondary"
        onClick={refreshData}>
          <SyncIcon />
       </IconButton>
      
      </div>
    </div>

    <TransfersTable data={transfers} editable={true}/>
    <div>Count: {transfers.length}</div>

    </div>
  )

}

export default Transfers





export function TransfersTable (props) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = React.useState(props.startPage || 0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage || 10);
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState({})

  let Rows = props.data
  let UpdateRows = JSON.parse(JSON.stringify(Rows))
  

  let editValue
  
  const editBooking = (id, booking_id, transfer_type_id, value) => {
    console.log('DEBUG', id, booking_id, value);
    setEdit({id, booking_id, transfer_type_id, value})
    setOpen(true);

  };

  const handleSave = () => {

    let changeValue = editValue
    
    console.log('DEBUG','DATA VALUE', editValue)

    helpers.postAPI(
         { func: function(data) {

              //After receiving response from server
              if (data.status === 'OK') {

                dispatch({type: Actions.UPDATE_TRANSFER, 
                          book_id: edit.booking_id,
                          transfer_type_id: edit.transfer_type_id,
                          column: edit.id,
                          value: changeValue})

              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+data.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/postdb',
           data: {what: "transfers",
                  book_id: edit.booking_id,
                  transfer_type_id: edit.transfer_type_id,
                  column: edit.id,
                  value: changeValue}
         })

    setOpen(false);
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
  <section>


      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{(edit.id) && transfer_columns.find((c)=>c.id===edit.id).label}</DialogTitle>
        <DialogContent>

          {(edit.id && (edit.id === "pickup_date" || edit.id === "return_date") ) && (
               
             <DateSelector defDate={edit.value} onSet={(d)=>{editValue=d}} />

            )}

          {(edit.id && (edit.id === "pickup_time" || edit.id === "return_time") ) && (
               
             <TimeSelector defTime={edit.value} onSet={(d)=>{editValue=d}} />

            )}

    
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>







     <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {transfer_columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.book_id+'.'+row.transfer_type_id}>
                  {transfer_columns.map((column) => {
                    const value = row[column.id];
                    return (
                      
                      <TableCell key={column.id} align={column.align}>

                        { 
                            (column.id === "book_id") ? 
                                <Button color="primary" onClick={() => history.push('/bookings/'+value)}>{value}</Button>
                            
                            : ( (column.format) ? column.format(value) : value )
                         }
    

                        { ( (column.id === "pickup_date" || 
                             column.id === "pickup_time" ||
                             column.id === "return_date" ||
                             column.id === "return_time") && props.editable === true) && (
                                   <IconButton color="primary" component="span" size="small">
                                       <EditIcon fontSize="inherit" edge="end" onClick={(e) => editBooking(column.id, row.book_id, row.transfer_type_id, value)}/>
                                   </IconButton>
                                     )}
                      </TableCell>
                      
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={Rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />

   </section>


    )


}
